import React from 'react';
import { ToggleLeft, ToggleRight } from 'lucide-react';

interface DevModeToggleProps {
  mockData: boolean;
  onToggle: () => void;
}

export function DevModeToggle({ mockData, onToggle }: DevModeToggleProps) {
  return (
    <div className="px-6 py-3 bg-gray-50 border-b border-gray-200">
      <div className="flex justify-end">
        <button
          type="button"
          onClick={onToggle}
          className={`flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-lg transition-colors ${
            mockData 
              ? 'bg-orange-50 text-orange-700 hover:bg-orange-100' 
              : 'bg-green-50 text-green-700 hover:bg-green-100'
          }`}
        >
          {mockData ? (
            <>
              <ToggleRight className="h-5 w-5" />
              Using Mock Data
            </>
          ) : (
            <>
              <ToggleLeft className="h-5 w-5" />
              Using Live Data
            </>
          )}
        </button>
      </div>
    </div>
  );
}